// Libs
import classNames from 'classnames/bind';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
// Components, Layouts, Pages
import { BaseDragDrop, BaseToolbar, UnderDevelopment } from '~/components/common';
import PageShell from '~/pages/common/pageShell/PageShell';
// Others
import { mockPipelineList } from '~/utils/mockData/pipeline';
import { ItemChangePipeline } from '~/utils/interface/pipeline';
// Styles, images, icons
import styles from './Pipeline.module.scss';

const cx = classNames.bind(styles);

const Pipeline = () => {
  //#region Destructuring Props
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/pipeline']);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  const [isShowUnderDevelopment, setIsShowUnderDevelopment] = useState<boolean>(false);
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  const handleItemChange = (item: ItemChangePipeline) => {};

  const handleCall = () => {
    setIsShowUnderDevelopment(true);
  };

  const handleMail = () => {
    setIsShowUnderDevelopment(true);
  };

  const handleCloseUnderDevelopment = () => {
    setIsShowUnderDevelopment(false);
  };
  //#endregion Handle Function

  return (
    <PageShell title={t('pipeline_title')}>
    <Box component={'div'} id='pipelinePage' className={cx('container')}>
      <BaseToolbar textAction={t('button_add_customer')} />

      <Box component={'div'} className={cx('body')}>
        <BaseDragDrop
          data={mockPipelineList}
          onItemChange={handleItemChange}
          onCall={handleCall}
          onMail={handleMail}
        />
      </Box>

      <UnderDevelopment isOpen={isShowUnderDevelopment} onClose={handleCloseUnderDevelopment} />
    </Box>
    </PageShell>
  );
};

export default Pipeline;
